export function getCalendarRelieveDayFollowUpIds({
  followUp,
  isChecked,
  selectedIds,
}) {
  return isChecked
    ? [...selectedIds, followUp.id]
    : selectedIds.filter(id => id !== followUp.id)
}

export function getIsCalendarRelieveDayRowDisabled({
  isLoading,
  isSubmitting,
}) {
  return isLoading || isSubmitting
}

export function getIsCalendarRelieveDayStillFull({ dayLoad, selectedCount }) {
  return dayLoad.used - selectedCount >= dayLoad.limit
}
